import { defineMessages } from 'react-intl';

const messages = defineMessages({
  batchName: {
    description: 'batch-name',
    defaultMessage: 'Batch Name',
    id: 'onYWUf',
  },
  assignedTo: {
    description: 'assigned-to',
    defaultMessage: 'Assigned To',
    id: 'BC8yjC',
  },
  shipmentsRatedCost: {
    description: 'shipments-rated-cost',
    defaultMessage: 'Shipments Rated Cost',
    id: 'dIw+6m',
  },
  shipmentCount: {
    description: 'shipment-count',
    defaultMessage: '# Shipments',
    id: 'hGGjoK',
  },
  processedDate: {
    description: 'processed-date',
    defaultMessage: 'Processed Date',
    id: 'uHN0LV',
  },
  packingSlipPrinted: {
    description: 'packing-slip-printed-count',
    defaultMessage: '# Packing Slips Printed',
    id: 'Aw/kQN',
  },
  createdDate: {
    description: 'batch-created-date',
    defaultMessage: 'Created',
    id: 'wfXfvF',
  },
  columnName: {
    description: 'batch-note',
    defaultMessage: 'Note',
    id: 'x4dnzK',
  },
  printedDate: {
    description: 'Shipments > Batches Grid > Printed Date',
    defaultMessage: 'Printed Date',
    id: 'YhGO8I',
  },
  processingProgressStatus: {
    description: 'Shipments > Batches > Status',
    defaultMessage: 'Status',
    id: 'aCiDwS',
  },
});

export default messages;
